import React, { useState, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import format from 'date-fns/format';
import { makeStyles, fade } from '@material-ui/core/styles';
import { notificationCenterWidth, RightSideBarWidth } from '../../../styleVariables';
import useMountEffect from '../../../mountEffect';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import * as logger from "../../../logger";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { connect } from 'react-redux';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import {
  updateChatView, toggleChatSupport, onlinePaymentsConfig
} from "../../../store/actions/userActionCreators";
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { freshChat } from '../../../configs/configs';
import FreshChat from 'react-freshchat';
import MobileStepper from '@material-ui/core/MobileStepper';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { biltyContinueClick } from '../../../store/actions/tripActionCreator';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ExcelIcon, PdfIconWhite } from '../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { getDriverLedgerV2 } from '../../../store/actions/homeActionCreator';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { numberFormat,numberFormatWithOutSpace, numberWithCommas, validNumberCheck, replaceCommas, findArrayObject } from '../../../utils/utils';
import { RightArrow } from '../TopCard/icons';
import Highlighter from "react-highlight-words";
import { Form } from 'react-final-form';
import {
  Checkboxes
} from 'mui-rff';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import AmountInput from '../Inputs/AmountInput';
import { InputAdornment } from '@material-ui/core';
import TextInputState from '../Inputs/TextInputState';
import { getBankDetails, getPaymentLink,getPaymentInitiate } from '../../../store/actions/OnlinePaymentActionCreators';
import { getRechargeLink, getSingleFastTagDetails,getWalletBalance} from '../../../store/actions/fastagActionCreators';
import AddIcon from '@material-ui/icons/Add';
import { trackDwebEvent } from '../../analytics';
import { getUserDetails } from '../../../store/actions/authActionCreators';
import { Paper } from '@material-ui/core';
import GooglePay from '../../../assets/googlepay.png'
import Paytm from '../../../assets/paytm.png'
import PhonePe from '../../../assets/phonepe.png'
import AllUPI from '../../../assets/upi.png'
import HDFC from '../../../assets/hdfc.png'
import SBI from '../../../assets/sbi.png'
import ICICI from '../../../assets/icici.png'
import AllBank from '../../../assets/allbank.png'
import RewardConsumptionDialog from '../Verfication/RewardConsumptionDialog';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import DwebPaymentGateWayDialog from '../Dialog/DwebPaymentGateWayDialog';

const GreenCheckbox = withStyles({
  root: {
      color: '#c7c7c7',
      '&$checked': {
          color: '#00875a',
      },
  },
  checked: {},
})((props) => <Checkboxes color="default" {...props} />);
const useStyles = makeStyles(theme => ({
  transactionDetailsDrawer: {
    width: 475,
    maxWidth: 475,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  backdrop: {
    [theme.breakpoints.down('sm')]: {
      top: '0px',
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px',
      backgroundColor: 'transparent !important'
    }
  },
  container: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1,
    flexGrow: 1
  },
  sideBarDialogContentV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    backgroundColor: '#f6f6f8'
  },
  divTitle: {
    display: 'flex',
    alignItems: 'center',
    color: "#0b1323",
    fontSize: 18,
    marginBottom: 4
  },
  divSecTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: "rgba(11, 19, 35, 0.75);",
    marginBottom: 8
  },
  titleDiv: {
    display: 'flex',
    flexDirection: 'column'
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fff",
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    border: "solid 1px rgba(11, 19, 35, 0.5)",
    marginRight: 0,
    marginLeft: 0,
    width: '100%',
  },
  sicon: {
    fontSize: 18
  },
  searchIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    fontSize: 14,
    padding: "9px 0px",
    //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    width: '100%'
  },
  sideBarActions: {
    paddingTop: 24,
    paddingBottom: '24px !important',
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: 'white'
  },
  subTitleSec: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  bankSubTitleSec: {
    marginBottom: 2,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:last-child': {
      marginBottom: 0
    }
  },
  listingDiv: {
    marginTop: 24
  },
  subTitleTxt: {
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(11, 19, 35, 0.5)"
  },
  driverDiv: {
    padding: 16,
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    //transition:'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    marginBottom: 12,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'cente',
    justifyContent: 'space-between'
  },
  nameDiv: {
    display: 'flex',
    flexDirection: 'column',
    //alignItems:'center',
    fontSize: 16
  },
  bankValueDiv: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 16
  },
  balanceDiv: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  listDriverBalance: {
    fontWeight: 600
  },
  listDriverBalancePositive: {
    fontWeight: 600,
    color: "#379953"
  },
  listDriverBalanceNegative: {
    fontWeight: 600,
    color: "#ff0000"
  },
  highlight: {
    color: "#1860f0",
    padding: 0
  },
  driverDetailsDiv: {
    padding: "16px 24px",
    borderRadius: 8,
    border: "solid 1px #dcdcdc",
    backgroundColor: " #ededed",
    marginBottom: 24,
    marginTop: 2
  },
  bankDetailsDiv: {
    padding: 16,
    borderRadius: 8,
    backgroundColor: " #fff",
    marginBottom: 24,
    marginTop: 2
  },
  infoDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  titleV2: {
    fontSize: 14,
    fontWeight: 600,
    color: '#6b778c',
    marginBottom: 4
  },
  divV2: {
    color: '#2c5de5',
    marginLeft: 6
  }, divActionsRecharge: {
    width: '100%'
  },
  bankListImg: {
    width: 374,
    height: 149
  },
  newInput: {
    backgroundColor: '#fff',
    paddingLeft: 16,
    border: "solid 1px #dedede",
    "& .MuiInputBase-input": {
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 0
    }
  },
  changeButton: {
    padding: "8px 16px",
    borderRadius: 8,
    border: "solid 1px #f1f1f1",
    backgroundColor: " #0033cc",
    fontSize: 12,
    fontWeight: 600,
    color: "#fff",
    "&:hover": {
      backgroundColor: " #0033cc",
    }
  },
  addBankDetailsButton: {
    padding: "12px 16px 12px 12px",
    borderRadius: 4,
    border: "solid 1px #0033cc",
    backgroundColor: "#0033cc",
    fontSize: 16,
    fontWeight: 600,
    color: "#fff",
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#0033cc",
    }
  },
  verifiedAccount: {
    fontSize: 12,
    color: "rgba(21, 128, 38, 0.6)"
  },
  unVerifiedAccount: {
    fontSize: 12,
    color: "#e93333"
  },
  valueTxt: {
    textTransform: 'capitalize',
    fontWeight: 600
  },
  valueTxt1: {
    textTransform: 'capitalize',
  },
  alignEnd: {
    textAlign: 'end'
  },
  rechargeButton: {
    paddingTop: 17,
    paddingBottom: 17,
    borderRadius: 8,
    boxShadow: 'none',
    backgroundColor: '#00875a',
    fontSize: 14,
    fontWeight: 600,
    width: '100%',
    color: '#fff',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#00875a",
    }
  },
  balance: {
    color: "rgba(11, 19, 35, 0.75)",
    fontSize: 12,
    paddingLeft: 8,
    textTransform: 'uppercase'
  },
  driverName: {
    fontSize: 12
  },
  listTruckNo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  paper: {
    textAlign: 'center',
    color: "rgba(11, 19, 35, 0.6)",
    fontSize:12,
    fontWeight:600,
    display:"flex",
    flexDirection:"column",
    justifyContent:'center',
    alignItems:'center'
  },
  iconDesc:{
    margin:0,
    color: "rgba(11, 19, 35, 0.6)",
    fontSize:12,
    fontWeight:600,
    textAlign:'center'
  },
  pageContentDIv: {
    //marginTop:30,
    padding: 24,
    height: 'calc(100vh - 115px)',
    overflow: 'auto'
  },
  balanceConsumption:{
    marginTop:8,
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  switchLabel: {
      fontSize: '16px !important',
      fontWeight:600
  },
  switchControl:{
    "& .MuiFormControlLabel-root":{
      marginRight:0,
      marginBottom:0
    }
  }
}));

const RechargeFastagSideBar = ({
  rightSideBarOpen,
  toggleRightSideBar,
  user,
  defaultData,
  children,
  sideBarName,
  sideBarTitle,
  sideBarSecondaryTitle,
  handleSubmit,
  dispatchChatView,
  dispatchFetchBankDetails,
  dispatchGetRechargetLink,
  dispatchGetUserDetails,
  dispatchGetOnlinePaymentsConfig,
  dispatchGetWalletBalance,
  fastag,
  dispatchGetPaymentInitiate
}) => {
  let submit, formValues;
  let history = useHistory();
  const classes = useStyles();
  const [updateChatView, setChatView] = useState(false);
  const [progress, setProgress] = useState(25);
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [driverSearchTxt, setDriverSearchTxt] = useState("");
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [bankList, setBankList] = useState([]);
  const [amount, setAmount] = useState(defaultData && defaultData.amount ? numberWithCommas(defaultData.amount) : null);
  const [saveAsExpense, setSaveAsExpense] = useState(defaultData && defaultData.saveAsExpense ? defaultData.saveAsExpense : true);
  const [singleFastagData, setSingleFastagData] = useState({});
  const [rewardConsumption, setRewardConsumption] = useState(false);
  const [rewardAmount, setRewardAmount] = useState(0);

  //Payment GateWay
  const [customPGOpen, setCustomPGOpen] = useState(false);
  const [cashFreeOrderData,setCashFreeOrderData] = useState(null);
  const [orderRequestData,setOrderRequestData] = useState(null);
  useEffect(() => {

    if (fastag && fastag.singleFastTagDetails) {
      setSingleFastagData(fastag.singleFastTagDetails);
    }
  }, [fastag.singleFastTagDetails]);
  const goToViewFastag = (data,amount) => {
    const fastTagStatus = data && data.status ? data.status : "";
    const fastTagId = defaultData && defaultData.id ? defaultData.id : "";
    const vehicleNumberPreffix = data.vehicleNumberPrefix;
    const vehicleNumberSuffix = data.vehicleNumberSuffix;
    const status = data.status;
    const fastTagBalance = data && data && data.balanceAmount ? data.balanceAmount : "";
    history.push({
        pathname: `/fastag/single-truck/${fastTagId}${data.rewardAmountUsed?`?rewardAmountUsed=${data.rewardAmountUsed}`:''}`,
        state: {
            id: fastTagId,
            fastagBalance: fastTagBalance || null,
            pageTitle: [vehicleNumberPreffix, vehicleNumberSuffix],
            fastTagId: fastTagId,
            rewardAmountUsed:data.rewardAmountUsed?data.rewardAmountUsed:null
        }
    });
}
  useEffect(() => {
    dispatchChatView(false);
  }, []);

  const handleCustomPGClose = () => {
    setCustomPGOpen(false);
    setOrderRequestData(null);
    setCashFreeOrderData(null);
    //handleClose(true)
    dispatchGetWalletBalance(
      (data) => {
          if (data && data.status && data.status.code == 200) {
          }
      },
      () => {
      }
  )
  }
  const handleCustomPGConfirm = () => {
    setCustomPGOpen(false);
    setOrderRequestData(null);
    setCashFreeOrderData(null);
    handleClose(true)
  }

  const handleRewardsOpen = () => {
      setRewardConsumption(true)
  }
  const handleRewardsClose = (data) => {
      setRewardConsumption(false)
      goToViewFastag(singleFastagData)
  }
  const handleClose = () => {
    dispatchChatView(true);
    if (toggleRightSideBar) {
      toggleRightSideBar()
    }
  }


  const handleSave = () => {
    if (handleSubmit) {
      handleSubmit()
    }
    //dispatchChatView(true);
  }
  const validate = values => {

    const errors = {};
    const minAmount = singleFastagData && singleFastagData.minRechargeAmount ? singleFastagData.minRechargeAmount : 0;
    const maxAmount = singleFastagData && singleFastagData.maxRechargeAmount ? singleFastagData.maxRechargeAmount : 0;
    if (!values.amount) {
      errors.amount = 'Amount Required';
    }
    if (values.amount && !validNumberCheck(values.amount)) {
      errors.amount = 'Invalid Amount';
    }

    if (values.amount && validNumberCheck(values.amount)) {

      if (Number(replaceCommas(values.amount)) > Number(maxAmount)) {
        errors.amount = 'Amount cannot be greater than ' + numberFormat(maxAmount);
      } else if (Number(replaceCommas(values.amount)) < Number(minAmount)) {
        errors.amount = 'Amount cannot be less than ' + numberFormat(minAmount);
      }

    }

    return errors;
  };

  let initialValues = {
    amount: amount,
    saveAsExpense:saveAsExpense
  };

  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    handlePayNow(values);
  };

  const handlePayNow = (values) => {
    let realAmount = Number(replaceCommas(amount));
    let payableAmount = realAmount
    let walletBalance = fastag && fastag.walletBalance?fastag.walletBalance:0;
    /*if(walletBalance && realAmount && realAmount > walletBalance){
      payableAmount = realAmount - walletBalance;
    }else if(walletBalance && realAmount && realAmount < walletBalance){
      payableAmount = realAmount;
    }*/
    let reqData = {
      "rechargeAmount": payableAmount,
      "vehicleId": `${defaultData && defaultData.id ? defaultData.id : ""}`,
      "paymentView": "web_v2",
      "saveAsExpense":values.saveAsExpense,
      "returnUrl": `${(process.env.REACT_APP_URL).trim()}/fastag/single-truck/${defaultData && defaultData.id ? defaultData.id:''}`
    }
    dispatchGetRechargetLink(reqData, (data) => {
      let rewardAmountUsed = data && data.response && data.response.rewardAmountUsed?data.response.rewardAmountUsed:null 
      if (data && data.status && data.status.code == 200 && rewardAmountUsed && Number(rewardAmountUsed) !=0) {
          let realAmount =  Number(replaceCommas(amount)) - rewardAmountUsed;
            if(realAmount>0){
              setOrderRequestData({
                ...reqData,
                orderAmount: Number(replaceCommas(data.response.orderAmount)),
                payeeType:'FASTAG',
                //finalBank:finalBank[0],
                truckInfo:singleFastagData,
                returnUrl: `${window.location.href}`
              });
              setCashFreeOrderData(data.response);
              setCustomPGOpen(true)
          }else{
            let port = window.location.port;
            window.location.href = `${window.location.protocol}//${window.location.hostname}${port?`:${port}`:''}/fastag/single-truck/${defaultData && defaultData.id ? defaultData.id:''}${data.response.rewardAmountUsed?`?rewardAmountUsed=${data.response.rewardAmountUsed}`:''}`;
          }
      }else if (data && data.status && data.status.code == 200 && data.response && data.response && data.response.orderAmount) {
        setOrderRequestData({
          ...reqData,
          orderAmount: Number(replaceCommas(data.response.orderAmount)),
          payeeType:'FASTAG',
          //finalBank:finalBank[0],
          truckInfo:singleFastagData,
          returnUrl: `${window.location.href}`
        });
        setCashFreeOrderData(data.response);
        setCustomPGOpen(true)
        //handleClose(true)
    }else{
      handleClose(true)
    }
      /*if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
        window.location.href = data.response.paymentLink;
      }else if (data && data.status && data.status.code == 200 && data.response && data.response.rewardAmountUsed) {
        let port = window.location.port;
        window.location.href = `${window.location.protocol}//${window.location.hostname}${port?`:${port}`:''}/fastag/single-truck/${defaultData && defaultData.id ? defaultData.id:''}${data.response.rewardAmountUsed?`?rewardAmountUsed=${data.response.rewardAmountUsed}`:''}`;
        /*goToViewFastag({
          ...singleFastagData,
          rewardAmountUsed:data.response.rewardAmountUsed
        })*/
        /*setRewardAmount(data.response.rewardAmountUsed)
        handleRewardsOpen()
        setTimeout(() => {
            handleRewardsClose({
              ...singleFastagData,
              rewardAmountUsed:data.response.rewardAmountUsed
            })
        }, 3000);*
      }
      handleClose()*/
    }, (data) => {
      handleClose()
    })
  }
  const getPayableAmount = ()=>{
    let realAmount = Number(replaceCommas(amount));
    let payableAmount = realAmount
    let walletBalance = fastag && fastag.walletBalance?fastag.walletBalance:0;
    if(singleFastagData && singleFastagData.isGoodsVehicle){
      if(walletBalance && realAmount && realAmount == walletBalance){
        payableAmount = 0;
      }else if(walletBalance && realAmount && realAmount > walletBalance){
        payableAmount = realAmount - walletBalance;
      }else if(walletBalance && realAmount && realAmount < walletBalance){
        payableAmount = 0;
      }
    }
    return payableAmount;
  }
  const getPayableLabel = ()=>{
    let realAmount = Number(replaceCommas(amount));
    let payableAmount = "Recharge";
    let walletBalance = singleFastagData && singleFastagData.isGoodsVehicle && fastag && fastag.walletBalance?fastag.walletBalance:0;
    if(walletBalance && realAmount && realAmount == walletBalance){
      payableAmount = "Recharge";
    }else if(walletBalance && realAmount && realAmount > walletBalance){
      payableAmount = "Pay";
    }else if(walletBalance && realAmount && realAmount < walletBalance){
      payableAmount = "Recharge";
    }
    if(walletBalance ==0){
      payableAmount = "Pay"
    }
    return payableAmount;
  }
  const getFormFields = (values) => {
    /*let realAmount = Number(replaceCommas(values.amount));
    let payableAmount = realAmount
    let walletBalance = fastag && fastag.walletBalance?fastag.walletBalance:0;
    if(walletBalance && realAmount && realAmount > walletBalance){
      payableAmount = realAmount - walletBalance;
    }else if(walletBalance && realAmount && realAmount < walletBalance){
      payableAmount = realAmount;
    }*/
    let walletBalance = fastag && fastag.walletBalance?fastag.walletBalance:0;
    return [
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={classes.titleV2}>Amount *</div>
            <AmountInput
              // label="Truck Hire Cost"
              placeholder="Enter a amount"
              name="amount"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setAmount(e.target.value)
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                className: classes.newInput,
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              required={true}
            />
            {singleFastagData && singleFastagData.isGoodsVehicle && values && values.amount && walletBalance != 0 && <div className={classes.balanceConsumption}>
                <div>Wallet Balance:&nbsp;<strong>{fastag && fastag.walletBalance?numberFormat(Number(fastag.walletBalance)):numberFormat(Number(0))}</strong></div>
                <div>Amount to Pay:&nbsp;<strong>{numberFormat(getPayableAmount())}</strong></div>
            </div>}
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        inline: false,
        field: (<div style={{width:'100%',display:'flex',alignItems:'center'}}>
          <GreenCheckbox
            size='small'
            margin='normal'
            //fullWidth={true}
            formControlProps={{
                className: classes.switchControl
            }}
            onChange={(e, value) => {
                setSaveAsExpense(value)
            }}
            formGroupProps={{}}
            formControlLabelProps={{
                classes: {
                    label: classes.switchLabel
                },
                labelPlacement: 'end',
            }}
            name="saveAsExpense"
            data={{ label:"Mark this Recharge as Truck Expense ", value: true }} label="" />
            <Tooltip title="Keep this tick marked if you do not add Toll Expenses for Trips" placement="top" arrow><InfoOutlinedIcon style={{color:'#6B778C',fontSize:16,marginTop:3,marginLeft:3}}/></Tooltip>
          </div>)
    }
    ]
  }

  return (
    <>
    <Drawer
      variant="temporary"
      anchor="right"
      open={rightSideBarOpen}
      ModalProps={{
        keepMounted: false,
        className: classes.modal,
        BackdropProps: {
          className: classes.backdrop
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        //onBackdropClick: handleClose
      }}
      classes={{
        paper: classes.transactionDetailsDrawer
      }}
    >
      <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} siderBarType={'truckBook'} onClose={handleClose}>
        <div className={classes.titleDiv}>
          <div className={classes.divTitle}>
            {sideBarTitle ? sideBarTitle : 'Recharge FASTag'}
          </div>
          {/* <div className={classes.divSecTitle}>
                  {sideBarSecondaryTitle ? sideBarSecondaryTitle : 'Title'}
            </div> */}
        </div>
      </SideBarDialogTitle >
      <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >
        <div>
          <div className={classes.driverDetailsDiv}>
            <div className={classes.subTitleSec} >
              <Typography className={classes.subTitleTxt}>Truck No</Typography>
              {singleFastagData && singleFastagData.balanceAmount && Number(singleFastagData.balanceAmount) > 0 ?
              <Typography className={classes.subTitleTxt}>FASTag Balance</Typography>:null}
            </div>
            <div className={classes.infoDiv}>
              <div className={classes.nameDiv}>
                <div className={classes.listTruckNo}>
                  {singleFastagData && singleFastagData.vehicleNumArrayDweb && singleFastagData.vehicleNumArrayDweb.map((truckNumber, index) => (
                    <div className={index == (singleFastagData.vehicleNumArrayDweb.length - 1) ? classes.divV2 : ""} >{truckNumber}</div>
                  ))}
                </div>
              </div>
              {singleFastagData && singleFastagData.balanceAmount && Number(singleFastagData.balanceAmount) > 0 ?<div className={classes.balanceDiv} >
                <Typography>{singleFastagData && singleFastagData.balanceAmount ? numberFormat(Number(singleFastagData.balanceAmount)) : numberFormat(0)}</Typography>
              </div>:null}
            </div>
          </div>
          <Form
            onSubmit={onSubmit}
            //keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; formValues = values; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={3}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx} className={classes.ptV1}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />
        </div>
        <div>
          {/* <img className={classes.bankListImg} src={`${process.env.PUBLIC_URL}/assets/images/bank_grid.png`} alt={"Banklist"} /> */}
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={GooglePay} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>Google Pay</p>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={Paytm} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>Paytm</p>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={PhonePe} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>PhonePe</p>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={AllUPI} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>All UPI</p>
              </div>            
            </Grid>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={HDFC} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>HDFC Bank</p>
              </div>            
            </Grid>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={SBI} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>SBI Bank</p>
              </div>            
            </Grid>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={ICICI} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>ICICI Bank</p>
              </div>            
            </Grid>
            <Grid item xs={3}>
              <div className={classes.paper}>
                <img src={AllBank} style={{width:55.6,height:34.7}}/>
                <p className={classes.iconDesc}>All Banks</p>
              </div>            
            </Grid>            
          </Grid>
        </div>
      </SideBarDialogContent>
      <SideBarDialogActions className={classes.sideBarActions} >
        <div className={classes.divActionsRecharge}>
          {/* <Button variant="contained" className='modal-close-cta' onClick={() => { setSelectedDriver(null); setDriverSearchTxt("") }} >
              Back
            </Button> */}
          <Button disabled={Object.keys(validate(initialValues)).length != 0} variant="contained" className={classes.rechargeButton} onClick={event => submit(event)} >
            {amount?getPayableLabel():'Recharge'}&nbsp;&nbsp;{amount && getPayableLabel() !='Recharge'?numberFormatWithOutSpace(Number(getPayableAmount())):''}
          </Button>
        </div>
      </SideBarDialogActions>
    </Drawer >
    {rewardConsumption && <RewardConsumptionDialog selectedValue={null}  open={rewardConsumption} subTitle={numberFormat(Number(rewardAmount))} title={"You Saved"} onClose={handleRewardsClose} />}
    {customPGOpen && <DwebPaymentGateWayDialog open={customPGOpen} orderRequestData={orderRequestData} cashFreeOrderData={cashFreeOrderData} onClose={handleCustomPGClose} onSave={handleCustomPGConfirm} />}
    </>
  );
};

RechargeFastagSideBar.propTypes = {
  rightSideBarOpen: PropTypes.bool,
  toggleRightSideBar: PropTypes.func
};
const RechargeFastagSideBarWithRouter = withRouter(RechargeFastagSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value)),
  dispatchFetchBankDetails: (data, onSuccess, onFailure) => (dispatch(getBankDetails(data, onSuccess, onFailure))),
  dispatchGetRechargetLink: (data, onSuccess, onFailure) => (dispatch(getRechargeLink(data, onSuccess, onFailure))),
  dispatchGetPaymentInitiate: (data, onSuccess, onFailure) => (dispatch(getPaymentInitiate(data, onSuccess, onFailure))),
  dispatchGetOnlinePaymentsConfig: (onSuccess, onFailure) => { dispatch(onlinePaymentsConfig(onSuccess, onFailure)) },
  dispatchGetUserDetails: (onSuccess, onFailure) => { dispatch(getUserDetails(onSuccess, onFailure)) },
  dispatchGetSingleFastagVehicleDetails: (id, onSuccess, onFailure) => {
    dispatch(getSingleFastTagDetails(id, onSuccess, onFailure));
  },
  dispatchGetWalletBalance: (onSuccess, onError) => {
    dispatch(getWalletBalance(onSuccess, onError))
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RechargeFastagSideBarWithRouter);
